/**
 * OKX Exchange Metadata
 */

import { OKX_WS_CHANNELS, OKX_WS_TOPOLOGY } from './ws';

import type { ExchangeId } from '../../lib/types';

export const OKX_METADATA = {
  id: 'okx' as ExchangeId,
  restDocs: [
    'https://www.okx.com/docs-v5/en/',
    'https://www.okx.com/docs-v5/en/#public-data-rest-api-get-instruments',
    'https://www.okx.com/docs-v5/en/#order-book-trading-market-data-get-ticker',
    'https://www.okx.com/docs-v5/en/#order-book-trading-market-data-get-candlesticks',
    'https://www.okx.com/docs-v5/en/#order-book-trading-market-data-get-order-book',
    'https://www.okx.com/docs-v5/en/#order-book-trading-market-data-get-trades',
  ],
  wsDocs: [
    'https://www.okx.com/docs-v5/en/#websocket-api-public-channel',
    'https://www.okx.com/docs-v5/en/#order-book-trading-market-data-ws-tickers-channel',
    'https://www.okx.com/docs-v5/en/#order-book-trading-market-data-ws-order-book-channel',
    'https://www.okx.com/docs-v5/en/#order-book-trading-market-data-ws-candlesticks-channel',
  ],
  wsTopology: OKX_WS_TOPOLOGY,
  wsChannels: OKX_WS_CHANNELS,
  notes: [
    'Multiple WebSocket endpoints: public (ticker/trades/depth), business (candles), ipublic (private orderbook).',
    'Symbol format: dash-separated uppercase (BTC-USDT).',
    'Send "ping" text every 30s, server responds with "pong".',
    'Orderbook has action field: "snapshot" for initial state, "update" for incremental changes.',
    'REST klines returned in reverse chronological order (newest first).',
    'IMPORTANT: Interval unit is case-sensitive - "m" = minutes, "M" = months.',
    'Response code "0" indicates success.',
  ],
} as const;
